export default "__VITE_ASSET__NTF2vXRj__"